/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FishbrainExportStatusResponse
 */
export interface FishbrainExportStatusResponse {
    /**
     * 
     */
    status: FishbrainExportStatusResponseStatusEnum;
    /**
     * 
     */
    done: number;
    /**
     * 
     */
    total: number | null;
    /**
     * 
     */
    downloadUrl: string | null;
    /**
     * 
     */
    error: string | null;
}


/**
 * @export
 */
export const FishbrainExportStatusResponseStatusEnum = {
    Running: 'running',
    Complete: 'complete',
    Error: 'error',
} as const;
export type FishbrainExportStatusResponseStatusEnum = typeof FishbrainExportStatusResponseStatusEnum[keyof typeof FishbrainExportStatusResponseStatusEnum];


/**
 * Check if a given object implements the FishbrainExportStatusResponse interface.
 */
export function instanceOfFishbrainExportStatusResponse(value: object): value is FishbrainExportStatusResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('done' in value) || value['done'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if ((!('downloadUrl' in (value as Record<string, any>)) && !('download_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['downloadUrl'] === undefined && (value as Record<string, any>)['download_url'] === undefined)) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function FishbrainExportStatusResponseFromJSON(json: any): FishbrainExportStatusResponse {
    return FishbrainExportStatusResponseFromJSONTyped(json, false);
}

export function FishbrainExportStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FishbrainExportStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'done': json['done'],
        'total': json['total'],
        'downloadUrl': json['download_url'],
        'error': json['error'],
    };
}

export function FishbrainExportStatusResponseToJSON(json: any): FishbrainExportStatusResponse {
    return FishbrainExportStatusResponseToJSONTyped(json, false);
}

export function FishbrainExportStatusResponseToJSONTyped(value?: FishbrainExportStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'done': value['done'],
        'total': value['total'],
        'download_url': value['downloadUrl'],
        'error': value['error'],
    };
}

